import React from 'react';
import { useRole } from '../context/RoleContext';
import { GraduationCap, BookOpen, MessageCircle } from 'lucide-react';

const RoleToggle = () => {
  const { role, toggleRole, currentUser } = useRole();
  const isStudent = role === 'student';

  // WhatsApp Business link - replace with your actual number
  const whatsappNumber = "5215512345678"; // Format: country code + number without + or spaces
  const whatsappMessage = encodeURIComponent("Hola, necesito soporte con Milo.");
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <div className="role-toggle-container" data-testid="role-toggle-container">
      {/* User Card with Role */}
      <div className="role-card" data-testid="role-card">
        <div className="flex items-center gap-3 mb-4">
          <img
            src={currentUser.avatar}
            alt={currentUser.name}
            className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-md"
          />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold truncate">{currentUser.name}</p>
            <p className="text-xs opacity-70 truncate">{currentUser.handle}</p>
          </div>
        </div>

        {/* Toggle Switch */}
        <div className="flex items-center justify-between bg-black/5 rounded-xl p-1">
          <button
            onClick={() => !isStudent && toggleRole()}
            className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg text-xs font-medium transition-all duration-300 ${
              isStudent 
                ? 'bg-white shadow-md text-gray-900' 
                : 'text-gray-500 hover:text-gray-700'
            }`}
            data-testid="student-toggle"
          >
            <GraduationCap className="w-4 h-4" />
            <span>Alumno</span>
          </button>
          <button
            onClick={() => isStudent && toggleRole()}
            className={`flex-1 flex items-center justify-center gap-2 py-2.5 px-3 rounded-lg text-xs font-medium transition-all duration-300 ${
              !isStudent 
                ? 'bg-gray-900 shadow-md text-white' 
                : 'text-gray-500 hover:text-gray-700'
            }`}
            data-testid="professor-toggle"
          >
            <BookOpen className="w-4 h-4" />
            <span>Profesor</span>
          </button>
        </div>
      </div>

      {/* Disclaimer - Now at bottom */}
      <p className="text-[10px] text-center px-3 pt-3 pb-2 leading-relaxed opacity-70">
        Estás viendo una demo de <em className="font-semibold not-italic"><i>Milo</i></em> en modo Alumno y Profesor. Cambia de modo cuando quieras.
      </p>

      {/* Support Link */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-1 mx-auto px-2.5 py-1 text-[9px] text-gray-400 hover:text-green-500 border border-gray-200 hover:border-green-300 rounded-full transition-all mb-3"
        data-testid="support-link"
      >
        <MessageCircle className="w-2.5 h-2.5" />
        <span>Obtener Soporte</span>
      </a>
    </div>
  );
};

export default RoleToggle;
